import { ref } from 'vue';

// Global state created once
const pageTitle = ref('');
const pageContext = ref('');
const isSidebarOpen = ref(false);

export function useAiContext() {
  const setAiContext = (title, context) => {
    pageTitle.value = title;
    pageContext.value = context.value;
  };
  
  const setSidebarOpen = (isOpen) => {
    isSidebarOpen.value = isOpen;
  };

  return {
    pageTitle,
    pageContext,
    setAiContext,
    isSidebarOpen,
    setSidebarOpen
  };
}
